import BusinessIcon from '@mui/icons-material/Business';
import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';
import { Card, Tab, Tabs } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  a11yProps,
  CustomTabPanel,
} from '../employees/components/tabs/EmployeeTabs';
import TeamContributions from './components/TeamContributions';

const AdminTeamContributions = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Card>
      <Tabs
        value={1}
        variant="scrollable"
        aria-label="basic tabs example"
        sx={{
          mb: 0,
        }}
      >
        <Tab
          icon={<BusinessIcon />}
          onClick={() => navigate('/admin/expenses')}
          label={t('expenses.companyExpenses')}
          {...a11yProps(0)}
        />
        <Tab
          icon={<Groups2OutlinedIcon />}
          onClick={() => navigate('/admin/team-contributions')}
          label={t('expenses.teamExpenses')}
          {...a11yProps(1)}
        />
      </Tabs>
      <CustomTabPanel value={1} index={1}>
        <TeamContributions />
      </CustomTabPanel>
    </Card>
  );
};

export default AdminTeamContributions;
